<template>
	<c-form ref="form">
		<template v-for="(item, i) in config">
			<unit-edit-list v-if="item.type == 'list'" :key="i" ref="complex" :config="item"></unit-edit-list>
			<div v-else-if="item.type == 'group'" :key="i">
				<c-form-item v-model="dataValue[item.code]" type="radio" :label="item.label" :name="item.code" :options="item.options"></c-form-item>
				<unit-edit-group ref="complex" :config="item" :current-group="dataValue[item.code]"></unit-edit-group>
			</div>
			<c-form-item v-else-if="item.type == 'thumb'" :key="i" :label="item.label">
				<c-radio-group v-model="thumbValue[item.code]" ref="thumb">
					<c-radio v-for="(style, j) in item.options" :key="j" :value="style.value" style="height: auto;">
						<c-image :src="style.image" style="width: 160px; height: 160px;"></c-image>
					</c-radio>
				</c-radio-group>
			</c-form-item>
			<c-form-item v-else-if="item.type == 'product'" :key="i" :label="item.label">
				<unit-edit-product ref="complex" :code="item.code"></unit-edit-product>
			</c-form-item>
			<c-form-item v-else-if="item.type == 'link_area'" :key="i" :label="item.label">
				<unit-edit-link-area ref="complex" :code="item.code"></unit-edit-link-area>
			</c-form-item>
			<c-form-item v-else v-model="dataValue[item.code]" :key="i" :type="item.type" :label="item.label" :name="item.code" :options="item.options" :multiple="item.multiple" :image-size="item.size" gallery :link-type="$route.query.type" :link-template="$route.query.id"></c-form-item>
		</template>
	</c-form>
</template>

<script>
	import unitEditList from './unit_edit_list.vue'
	import unitEditGroup from './unit_edit_group.vue'
	import unitEditProduct from './unit_edit_product.vue'
	import unitEditLinkArea from './unit_edit_link_area.vue'
	
	export default {
		components: {
			unitEditList,
			unitEditGroup,
			unitEditProduct,
			unitEditLinkArea
		},
		
		props: {
			config: Array,
			value: Object
		},
		
		data() {
			return {
				dataValue: {},
				thumbValue: {}
			}
		},
		
		watch: {
			value(val) {
				this.set(val || {});
			}
		},
		
		mounted() {
			this.set(this.value || {});
		},
		
		methods: {
			set(data) {
				this.config.forEach(item => {
					if ((item.type == 'radio' || item.type == 'group') && data[item.code] === undefined) {
						data[item.code] = item.options[0].value;
					} else if (item.type == 'thumb') {
						this.$set(this.thumbValue, item.code, data[item.code] === undefined ? item.options[0].value : data[item.code]);
					}
				});
				
				this.$refs.form.set(data);
				this.$refs.complex && this.$refs.complex.forEach(item => {
					item.set(data);
				});
			},
			
			submit: async function() {
				let data = this.$refs.form.serialize();
				
				await Promise.all(Array.from(this.config.filter(item => data[item.code] && (item.widthParam || item.heightParam)), item => {
					return new Promise(resolve => {
						let img = new Image();
						img.onload = function() {
							item.widthParam && (data[item.widthParam] = img.width);
							item.heightParam && (data[item.heightParam] = img.height);
							resolve();
						}
						img.src = data[item.code];
					});
				}))
				
				if (this.$refs.complex) {
					for (let i = 0; i < this.$refs.complex.length; i++) {
						let temp = await this.$refs.complex[i].submit();
						data = Object.assign(data, temp);
					};
				}
				
				data = Object.assign(data, this.thumbValue);
				
				return data;
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
